export class NotFoundError extends Error {
    constructor(type, id) {
        super(`${type} ${id} not found`);
        this.type = type;
        this.id = id;
        this.name = NotFoundError.name;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90LWZvdW5kLWVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL25vdC1mb3VuZC1lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLE9BQU8sYUFBYyxTQUFRLEtBQUs7SUFDdEMsWUFDVyxJQUFZLEVBQ1osRUFBVTtRQUVuQixLQUFLLENBQUMsR0FBRyxJQUFJLElBQUksRUFBRSxZQUFZLENBQUMsQ0FBQztRQUh4QixTQUFJLEdBQUosSUFBSSxDQUFRO1FBQ1osT0FBRSxHQUFGLEVBQUUsQ0FBUTtRQUduQixJQUFJLENBQUMsSUFBSSxHQUFHLGFBQWEsQ0FBQyxJQUFJLENBQUM7SUFDakMsQ0FBQztDQUNGIn0=